export default __webpack_public_path__ + "static/media/ourpride.633c5ebe.jpg";